import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const weightsAndBiases = defineConnector({
  identifier: "weightsAndBiases",
  name: "Weights & Biases",
  tagLine: "ML experiment tracking",
  logo,
  protocol: "http",
  tags: ["ai", "engineering", "data"],
  defaultUrlPattern: () => "https://api\\.wandb\\.ai/.*",
  auth: (app) =>
    basicAuth({
      username: "api",
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Copy your API key from [wandb.ai/authorize](https://wandb.ai/authorize).",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.wandb.ai/graphql",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "query { viewer { id } }" }),
      expectedBodyContains: '"id"',
    }),
  },
});
